import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import type { FunctionComponent } from "react";
import type { RouteProps } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { loginRequest } from "../../utils/authConfig";

const ProtectedRoute: FunctionComponent<RouteProps> = ({ children }) => (
  <MsalAuthenticationTemplate
    authenticationRequest={loginRequest}
    interactionType={InteractionType.Redirect}
  >
    {children != null ? children : <Outlet />}
  </MsalAuthenticationTemplate>
);

export default ProtectedRoute;
